import { render } from "./manageDetail.vue?vue&type=template&id=10ef69f8&scoped=true"
import script from "./manageDetail.vue?vue&type=script&lang=js"
export * from "./manageDetail.vue?vue&type=script&lang=js"

import "./manageDetail.vue?vue&type=style&index=0&id=10ef69f8&lang=scss&scoped=true"
import "./manageDetail.vue?vue&type=style&index=1&id=10ef69f8&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ef69f8"]])

export default __exports__